export default __webpack_public_path__ + "static/media/TopImage.9dfceaee.mp4";